import DataService from '@/core/services/api/DataService';
import AuthService from '@/core/services/api/AuthService';

export default {
  data: new DataService(),
  auth: new AuthService()
};
